(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zogami-in-motion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-zim-section]';
    const getRoots = (scope) => {
      if (!scope) return [];
      const roots = [];
      if (scope.matches && scope.matches(selector)) roots.push(scope);
      if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach((node) => roots.push(node));
      return roots;
    };

    function init(root) {
      if (root.dataset.zimInitialized === 'true') return;
      root.dataset.zimInitialized = 'true';

      const stage = root.querySelector('[data-zim-stage]');
      const video = root.querySelector('[data-zim-moving-media] video');
      const toggle = root.querySelector('[data-zim-toggle]');
      const toggleLabel = root.querySelector('[data-zim-video-label]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const smallScreen = window.matchMedia('(max-width: 749px)');
      const cleanups = [];
      let playbackObserver = null;
      let entranceObserver = null;
      let inView = false;
      let userPaused = false;
      let userStarted = false;

      const supportedScreen = () => !smallScreen.matches || root.dataset.zimMobileVideo === 'true';
      const syncToggle = () => {
        if (!video || !toggle) return;
        const isPlaying = !video.paused && !video.ended;
        root.classList.toggle('zim--video-playing', isPlaying && supportedScreen());
        toggle.setAttribute('aria-pressed', String(isPlaying));
        toggle.setAttribute('aria-label', isPlaying ? 'Pause campaign video' : 'Play campaign video');
        if (toggleLabel) toggleLabel.textContent = isPlaying ? 'PAUSE FILM' : 'PLAY FILM';
      };
      const play = () => {
        if (!video || !supportedScreen() || !inView) return;
        if (reducedMotion.matches && !userStarted) return;
        if (!userStarted && (userPaused || root.dataset.zimAutoplay !== 'true')) return;
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(syncToggle);
      };
      const onToggle = () => {
        if (!video) return;
        if (!video.paused) {
          userPaused = true;
          userStarted = false;
          video.pause();
        } else {
          userPaused = false;
          userStarted = true;
          inView = true;
          play();
        }
      };
      const onPreferenceChange = () => {
        if (video && reducedMotion.matches && !userStarted) video.pause();
        if (video && !reducedMotion.matches && inView) play();
        if (reducedMotion.matches) {
          root.classList.remove('zim--animation-ready');
          root.querySelectorAll('[data-zim-enter]').forEach((node) => node.classList.add('is-in'));
        }
      };
      const onScreenChange = () => {
        if (video && !supportedScreen()) video.pause();
        else if (video && inView) play();
        syncToggle();
      };

      if (video && toggle && stage) {
        root.classList.add('zim--has-js-video');
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.addEventListener('playing', syncToggle);
        video.addEventListener('pause', syncToggle);
        video.addEventListener('ended', syncToggle);
        toggle.addEventListener('click', onToggle);
        cleanups.push(() => {
          video.removeEventListener('playing', syncToggle);
          video.removeEventListener('pause', syncToggle);
          video.removeEventListener('ended', syncToggle);
          toggle.removeEventListener('click', onToggle);
          video.pause();
        });
        if ('IntersectionObserver' in window) {
          playbackObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              inView = entry.isIntersecting;
              if (inView) play();
              else video.pause();
            });
          }, { threshold: .22 });
          playbackObserver.observe(stage);
        } else {
          // Without IntersectionObserver, do not automatically fetch or play video.
          inView = true;
        }
        syncToggle();
      }

      if (root.dataset.zimReveal === 'true' && !reducedMotion.matches && 'IntersectionObserver' in window) {
        const nodes = root.querySelectorAll('[data-zim-enter]');
        entranceObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            entranceObserver.unobserve(entry.target);
          });
        }, { threshold: .09, rootMargin: '0px 0px -20px 0px' });
        root.classList.add('zim--animation-ready');
        nodes.forEach((node) => entranceObserver.observe(node));
      }

      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', onPreferenceChange);
        cleanups.push(() => reducedMotion.removeEventListener('change', onPreferenceChange));
      }
      if (smallScreen.addEventListener) {
        smallScreen.addEventListener('change', onScreenChange);
        cleanups.push(() => smallScreen.removeEventListener('change', onScreenChange));
      }
      root.zimCleanup = () => {
        if (playbackObserver) playbackObserver.disconnect();
        if (entranceObserver) entranceObserver.disconnect();
        cleanups.forEach((cleanup) => cleanup());
        root.classList.remove('zim--has-js-video', 'zim--video-playing', 'zim--animation-ready');
        root.removeAttribute('data-zim-initialized');
        delete root.zimCleanup;
      };
    }

    const boot = (scope) => getRoots(scope).forEach(init);
    const unload = (scope) => getRoots(scope).forEach((root) => {
      if (typeof root.zimCleanup === 'function') root.zimCleanup();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('shopify:section:unload', (event) => unload(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zogami-sports-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const active = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function mount(root) {
      if (active.has(root)) return;
      const controller = new AbortController();
      const signal = controller.signal;
      const cleaners = [];
      const rail = root.querySelector('[data-zsc-track]');
      const gallery = root.querySelector('[data-zsc-gallery]');
      const more = root.querySelector('[data-zsc-more]');
      const moreCount = root.querySelector('[data-zsc-count]');
      const moreLabel = root.querySelector('[data-zsc-more-label]');
      const initial = Number(gallery?.dataset.zscInitial) || 8;
      const batch = Number(gallery?.dataset.zscBatch) || 8;
      const total = Number(gallery?.dataset.zscTotal) || 0;
      const offset = Number(gallery?.dataset.zscOffset) || 0;
      let nextUrl = gallery?.dataset.zscNextUrl || '';
      let busy = false;
      let raf = 0;
      let refreshCarousel = () => {};
      const isCarousel = root.dataset.zscLayout === 'carousel';
      const cards = () => rail ? Array.from(rail.querySelectorAll('.zsc__card')) : [];

      // Keep full catalogue and a collection link available without JavaScript.
      // Only hide the initial extras after this script has mounted successfully.
      if (rail && more) {
        cards().forEach((card, index) => { card.hidden = index >= initial; });
      }

      const revealNodes = root.querySelectorAll('[data-zsc-reveal]');
      if (root.dataset.zscEntrance === 'true' && 'IntersectionObserver' in window && !reducedMotion.matches) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('zsc__reveal--visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: .07, rootMargin: '0px 0px 35px 0px' });
        revealNodes.forEach(node => {
          node.classList.add('zsc__reveal--pending');
          observer.observe(node);
        });
        cleaners.push(() => {
          observer.disconnect();
          revealNodes.forEach(node => node.classList.remove('zsc__reveal--pending', 'zsc__reveal--visible'));
        });
      }

      function updateCount(finished = false) {
        if (!rail || !more) return;
        const shown = cards().filter(card => !card.hidden).length;
        if (moreCount) moreCount.textContent = `Showing ${Math.min(total, offset + shown)} of ${total} frames`;
        if (moreLabel && !busy) moreLabel.textContent = more.dataset.originalLabel || 'SHOW MORE FRAMES';
        const complete = finished || (offset + shown >= total && !nextUrl);
        if (complete) {
          more.hidden = true;
          if (moreCount) moreCount.textContent = `All ${total} frames are now shown`;
        }
        refreshCarousel();
      }

      async function fetchNextPage() {
        if (!nextUrl || !gallery || !rail) return;
        // Request the same page/template, because this section does not live on the collection page.
        const destination = new URL(window.location.href);
        const pagination = new URL(nextUrl, window.location.origin);
        pagination.searchParams.forEach((value, key) => destination.searchParams.set(key, value));
        destination.searchParams.set('section_id', gallery.dataset.zscSectionId);
        const response = await fetch(destination.toString(), { signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Section rendering failed: ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const loadedGallery = doc.querySelector('[data-zsc-gallery]');
        const loadedRail = loadedGallery?.querySelector('[data-zsc-track]');
        const incoming = loadedRail ? Array.from(loadedRail.querySelectorAll('.zsc__card')) : [];
        if (!incoming.length) throw new Error('The next product page was empty.');
        // Do not append duplicate products if Shopify returns an unexpected repeated page.
        // Index text comes from Liquid; actual product HTML stays entirely Shopify-rendered.
        const existingIds = new Set(cards().map(card => card.dataset.zscProductId));
        if (incoming.every(card => existingIds.has(card.dataset.zscProductId))) {
          throw new Error('Shopify returned a repeated product page.');
        }
        incoming.forEach(card => {
          if (existingIds.has(card.dataset.zscProductId)) return;
          card.hidden = true;
          rail.appendChild(card);
        });
        nextUrl = loadedGallery.dataset.zscNextUrl || '';
      }

      if (rail && more) {
        more.dataset.originalLabel = moreLabel?.textContent?.trim() || 'SHOW MORE FRAMES';
        more.addEventListener('click', async event => {
          if (more.dataset.fallback === 'true') return; // Navigate to the collection after an AJAX failure.
          event.preventDefault();
          if (busy) return;
          busy = true;
          more.setAttribute('aria-busy', 'true');
          if (moreLabel) moreLabel.textContent = 'LOADING FRAMES…';
          try {
            let concealed = cards().filter(card => card.hidden);
            // Fetch at most one 24-product page per click when the current page is exhausted.
            if (!concealed.length && nextUrl) {
              await fetchNextPage();
              concealed = cards().filter(card => card.hidden);
            }
            const newCards = concealed.slice(0, batch);
            newCards.forEach(card => { card.hidden = false; });
            if (newCards.length && isCarousel) {
              const first = newCards[0];
              requestAnimationFrame(() => {
                const delta = first.getBoundingClientRect().left - rail.getBoundingClientRect().left;
                rail.scrollBy({ left: delta, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
              });
            }
            busy = false;
            more.removeAttribute('aria-busy');
            updateCount();
            if (more.hidden && moreCount) moreCount.focus({ preventScroll: true });
          } catch (error) {
            if (error.name === 'AbortError') return;
            console.warn('ZOGAMI frame pagination:', error);
            busy = false;
            more.removeAttribute('aria-busy');
            more.dataset.fallback = 'true';
            if (moreLabel) moreLabel.textContent = 'VIEW ALL FRAMES';
            if (moreCount) moreCount.textContent = 'More frames are available in the full collection.';
            // The anchor's original href now works as a full-collection fallback.
          }
        }, { signal });
        updateCount();
      }

      if (rail && isCarousel) {
        const previous = root.querySelector('[data-zsc-prev]');
        const next = root.querySelector('[data-zsc-next]');
        const progress = root.querySelector('[data-zsc-progress]');
        const current = root.querySelector('[data-zsc-current]');
        const availableCards = () => cards().filter(card => !card.hidden);

        function metrics() {
          const card = availableCards()[0];
          if (!card) return { step: 1, max: 0 };
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          return { step: card.getBoundingClientRect().width + gap,
            max: Math.max(0, rail.scrollWidth - rail.clientWidth) };
        }
        function update() {
          raf = 0;
          const { step, max } = metrics();
          const left = Math.max(0, Math.min(max, rail.scrollLeft));
          if (previous) previous.disabled = left <= 2;
          if (next) next.disabled = left >= max - 2;
          if (progress) {
            const fraction = rail.scrollWidth ? Math.min(1, (left + rail.clientWidth) / rail.scrollWidth) : 1;
            progress.style.transform = `scaleX(${fraction})`;
          }
          if (current && availableCards().length) {
            const index = Math.max(1, Math.min(availableCards().length, Math.round(left / step) + 1));
            current.textContent = String(index + offset).padStart(2, '0');
          }
        }
        function schedule() { if (!raf) raf = requestAnimationFrame(update); }
        function advance(direction) {
          const { step } = metrics();
          const visible = Math.max(1, Math.floor((rail.clientWidth + 1) / step));
          rail.scrollBy({ left: direction * visible * step, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
        if (previous) previous.addEventListener('click', () => advance(-1), { signal });
        if (next) next.addEventListener('click', () => advance(1), { signal });
        rail.addEventListener('scroll', schedule, { passive: true, signal });
        rail.addEventListener('keydown', event => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            advance(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        if ('ResizeObserver' in window) {
          const resizer = new ResizeObserver(schedule);
          resizer.observe(rail);
          cleaners.push(() => resizer.disconnect());
        }
        refreshCarousel = schedule;
        schedule();
      }

      active.set(root, () => {
        controller.abort();
        cleaners.forEach(fn => fn());
        if (raf) cancelAnimationFrame(raf);
      });
    }

    function findRoots(scope) {
      const result = [];
      if (scope.nodeType === 1 && scope.matches('[data-zsc-section]')) result.push(scope);
      scope.querySelectorAll('[data-zsc-section]').forEach(root => result.push(root));
      return result;
    }
    function init(scope) { findRoots(scope).forEach(mount); }
    function unmount(scope) {
      findRoots(scope).forEach(root => {
        active.get(root)?.();
        active.delete(root);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => unmount(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zogami-sports-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zogami-sports-hero')) {
    customElements.define('zogami-sports-hero', class extends HTMLElement {
      connectedCallback() {
        this.mountFrame = requestAnimationFrame(() => {
          if (this.isConnected && !this.mounted) this.mount();
        });
      }

      mount() {
        this.mounted = true;
        this.videos = Array.from(this.querySelectorAll('.zsh__video'));
        if (this.videos.length !== 2) return;
        this.toggle = this.querySelector('.zsh__toggle');
        this.label = this.querySelector('[data-video-label]');
        this.mobileQuery = matchMedia('(max-width: 749px)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.listeners = [];
        this.generation = 0;
        this.activeSlot = 0;
        this.currentIndex = 0;
        this.urls = [];
        this.sourceKey = '';
        this.pendingPlay = false;
        this.switching = false;
        this.waitingForNext = false;
        this.blocked = false;
        this.userPaused = false;
        this.failedUrls = new Set();
        this.inView = !('IntersectionObserver' in window);

        try {
          this.videoPlaylist = JSON.parse(this.dataset.videoPlaylist || '[]');
        } catch (error) {
          this.videoPlaylist = [];
        }

        this.videos.forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          this.listen(video, 'playing', () => {
            if (video === this.videos[this.activeSlot] && this.canPlay()) {
              video.classList.add('is-visible');
              this.prepareNext();
            }
            this.updateControl();
          });
          this.listen(video, 'timeupdate', () => {
            if (video === this.videos[this.activeSlot]) this.maybeAdvance();
          });
          this.listen(video, 'ended', () => {
            if (video !== this.videos[this.activeSlot] || this.urls.length < 2) return;
            this.waitingForNext = true;
            this.advance(true);
          });
          this.listen(video, 'canplay', () => {
            if (video !== this.videos[this.activeSlot]) {
              if (this.waitingForNext) this.advance(true);
              else this.maybeAdvance();
            }
          });
          this.listen(video, 'error', () => {
            // Skip a missing or unplayable clip instead of trapping the playlist.
            if (!video.error || !video.dataset.clipUrl) return;
            this.failedUrls.add(video.dataset.clipUrl);
            this.refresh();
          });
          this.listen(video, 'pause', () => this.updateControl());
        });

        this.listen(this.mobileQuery, 'change', () => this.refresh());
        this.listen(this.motionQuery, 'change', () => this.refresh());
        this.listen(document, 'visibilitychange', () => this.refresh());
        this.listen(this.toggle, 'click', () => {
          // A blocked autoplay should start on the first manual click.
          if (this.blocked) {
            this.blocked = false;
            this.userPaused = false;
          } else {
            this.userPaused = !this.userPaused;
          }
          this.refresh();
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.refresh();
          }, { threshold: 0 });
          this.observer.observe(this);
        }
        this.refresh();
      }

      listen(target, event, handler) {
        if (!target) return;
        target.addEventListener(event, handler);
        this.listeners.push(() => target.removeEventListener(event, handler));
      }

      chooseSource(sources) {
        if (!Array.isArray(sources)) return '';
        const mp4 = sources.filter((source) => source && source.url && source.format === 'mp4');
        const edge = (source) => Math.max(Number(source.width) || 0, Number(source.height) || 0);
        mp4.sort((a, b) => edge(a) - edge(b));
        const cap = this.mobileQuery.matches ? 1280 : 1920;
        const suitable = mp4.filter((source) => edge(source) <= cap);
        const preferred = suitable[suitable.length - 1] || mp4[0];
        if (preferred) return preferred.url;
        const native = sources.find((source) =>
          source && source.url && source.mime_type && this.videos[0].canPlayType(source.mime_type));
        return native ? native.url : '';
      }

      selectedUrls() {
        const platform = this.mobileQuery.matches ? 'mobile' : 'desktop';
        return (Array.isArray(this.videoPlaylist) ? this.videoPlaylist : [])
          .map((slot) => this.chooseSource(slot && slot[platform]))
          .filter((url) => url && !this.failedUrls.has(url));
      }

      canPlay() {
        return this.isConnected && this.inView && !document.hidden &&
          !this.motionQuery.matches && !this.userPaused && !this.blocked;
      }

      // Reset on mobile/desktop changes or when a video becomes unplayable.
      configure(urls, key) {
        this.generation += 1;
        clearTimeout(this.fadeTimer);
        this.fadeTimer = null;
        this.sourceKey = key;
        this.urls = urls;
        this.currentIndex = 0;
        this.activeSlot = 0;
        this.pendingPlay = false;
        this.switching = false;
        this.waitingForNext = false;
        this.blocked = false;
        this.videos.forEach((video, index) => {
          video.pause();
          video.classList.remove('is-visible');
          video.style.zIndex = index === 0 ? '2' : '1';
          delete video.dataset.clipUrl;
          video.removeAttribute('src');
          video.preload = 'none';
          video.loop = false;
          video.load();
        });
        // Defer the first video download until the hero enters view.
      }

      attach(video, url) {
        if (!url || video.dataset.clipUrl === url) return;
        video.pause();
        video.classList.remove('is-visible');
        video.loop = false;
        video.preload = 'auto';
        video.dataset.clipUrl = url;
        video.src = url;
        video.load();
      }

      refresh() {
        if (!this.videos || this.videos.length !== 2) return;
        const urls = this.motionQuery.matches ? [] : this.selectedUrls();
        const key = JSON.stringify(urls);
        if (key !== this.sourceKey) this.configure(urls, key);
        if (!this.canPlay() || !this.urls.length) {
          this.videos.forEach((video) => video.pause());
          this.updateControl();
          return;
        }
        const active = this.videos[this.activeSlot];
        if (active.dataset.clipUrl !== this.urls[this.currentIndex]) {
          this.attach(active, this.urls[this.currentIndex]);
          active.loop = this.urls.length === 1;
        }
        if (this.urls.length > 1 && (active.ended || this.waitingForNext)) {
          this.waitingForNext = true;
          this.advance(true);
        } else if (!this.switching) {
          this.playActive();
        }
        this.updateControl();
      }

      playActive() {
        if (!this.canPlay() || this.pendingPlay || this.switching) return;
        const video = this.videos[this.activeSlot];
        if (!video.paused) {
          video.classList.add('is-visible');
          this.prepareNext();
          return;
        }
        this.pendingPlay = true;
        const generation = this.generation;
        video.play().then(() => {
          if (generation !== this.generation) return;
          if (!this.canPlay()) {
            video.pause();
            return;
          }
          video.classList.add('is-visible');
          this.prepareNext();
        }).catch((error) => {
          if (generation !== this.generation || error.name === 'AbortError') return;
          this.blocked = true;
        }).finally(() => {
          if (generation === this.generation) {
            this.pendingPlay = false;
            this.updateControl();
          }
        });
      }

      prepareNext() {
        if (this.urls.length < 2 || this.switching) return;
        const nextUrl = this.urls[(this.currentIndex + 1) % this.urls.length];
        this.attach(this.videos[1 - this.activeSlot], nextUrl);
      }

      maybeAdvance() {
        if (this.urls.length < 2 || this.switching || !this.canPlay()) return;
        const active = this.videos[this.activeSlot];
        if (!Number.isFinite(active.duration) || !active.duration) return;
        const remaining = active.duration - active.currentTime;
        if (remaining <= 0.85) this.advance(false);
      }

      advance(force) {
        if (this.urls.length < 2 || this.switching || !this.canPlay()) return;
        const current = this.videos[this.activeSlot];
        const incoming = this.videos[1 - this.activeSlot];
        const nextUrl = this.urls[(this.currentIndex + 1) % this.urls.length];
        if (incoming.dataset.clipUrl !== nextUrl) this.attach(incoming, nextUrl);
        if (incoming.readyState < 2) {
          if (force) this.waitingForNext = true;
          return;
        }
        this.switching = true;
        this.waitingForNext = false;
        const generation = this.generation;
        // Start displaying the incoming frame only after playback has begun.
        incoming.currentTime = 0;
        incoming.play().then(() => {
          if (generation !== this.generation) return;
          if (!this.canPlay()) {
            incoming.pause();
            this.switching = false;
            return;
          }
          incoming.style.zIndex = '3';
          current.style.zIndex = '2';
          incoming.classList.add('is-visible');
          this.fadeTimer = setTimeout(() => {
            if (generation !== this.generation) return;
            current.pause();
            current.classList.remove('is-visible');
            current.style.zIndex = '1';
            incoming.style.zIndex = '2';
            this.activeSlot = 1 - this.activeSlot;
            this.currentIndex = (this.currentIndex + 1) % this.urls.length;
            this.switching = false;
            this.fadeTimer = null;
            this.prepareNext();
            if (this.canPlay()) this.playActive();
            this.updateControl();
          }, 600);
        }).catch((error) => {
          if (generation !== this.generation) return;
          this.switching = false;
          this.waitingForNext = true;
          if (error.name !== 'AbortError' && incoming.error) {
            this.failedUrls.add(incoming.dataset.clipUrl);
            this.refresh();
          }
        });
      }

      updateControl() {
        if (!this.toggle || !this.label) return;
        this.toggle.hidden = this.dataset.showControls !== 'true' ||
          !this.urls.length || this.motionQuery.matches;
        const playing = this.videos.some((video) => !video.paused && !video.ended);
        this.toggle.dataset.playing = String(playing && !this.userPaused);
        const label = playing && !this.userPaused ? this.dataset.pauseLabel : this.dataset.playLabel;
        this.label.textContent = label;
        this.toggle.setAttribute('aria-label', label);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.mountFrame);
        clearTimeout(this.fadeTimer);
        if (this.observer) this.observer.disconnect();
        if (this.listeners) this.listeners.forEach((remove) => remove());
        if (this.videos) {
          this.videos.forEach((video) => {
            video.pause();
            video.removeAttribute('src');
            video.load();
          });
        }
        this.mounted = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
